export default function (arg) {
  throw Error(`"${arg || 'Unkown argument'}" is a required argument.`)
}
